//
//
//
//
//
//
//
//
//
//
//
//
//
export var VARIANTS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  P: 'p',
  SPAN: 'span'
};
export var TYPES = {
  ALL_CAPS: 'all-caps',
  HEADING_LARGE: 'heading-large',
  HEADING_MEDIUM: 'heading-medium',
  HEADING_SMALL: 'heading-small',
  BODY_LARGE: 'body-large',
  BODY_MEDIUM: 'body-medium',
  BODY_SMALL: 'body-small'
};
export default {
  name: 'Typography',
  props: {
    variant: {
      type: String,
      default: VARIANTS.P,
      validator: function validator(value) {
        return Object.values(VARIANTS).includes(value);
      }
    },
    type: {
      type: String,
      default: TYPES.NORMAL,
      validator: function validator(value) {
        return Object.values(TYPES).includes(value);
      }
    },
    isBold: {
      type: Boolean,
      default: false
    }
  }
};